// SimpleForms
import AtenObstForm from '../views/simpleForms/AtenObstForm.vue'
import AtencionForm from '../views/simpleForms/AtencionForm.vue'
import BitacoraForm from '../views/simpleForms/BitacoraForm.vue'
import CitaForm from '../views/simpleForms/CitaForm.vue'
//import EmpresaForm from '../views/simpleForms/EmpresaForm.vue'
import FacturaForm from '../views/simpleForms/FacturaForm.vue'
import InformeInterForm from '../views/simpleForms/InformeInterForm.vue'
import InterconsultaDestinoForm from '../views/simpleForms/InterconsultaDestinoForm.vue'
import InterconsultaForm from '../views/simpleForms/InterconsultaForm.vue'
import SuscripcionForm from '../views/simpleForms/SuscripcionForm.vue'
import TratamientoForm from '../views/simpleForms/TratamientoForm.vue'
import UsuarioForm from '../views/simpleForms/UsuarioForm.vue'
import UsuarioResumenForm from '../views/simpleForms/UsuarioResumenForm.vue'

export default [
  {
    path: '/atenobstform/:p_idatencion/:p_numero/:p_estadoatencion',
    name: 'AtenObstForm',
    component: AtenObstForm
  },
  {
    path: '/bitacoraform/:p_idpersona/:p_nombre',
    name: 'BitacoraForm',
    component: BitacoraForm
  },
  {
    path: '/citaform',
    name: 'CitaForm',
    component: CitaForm
  },
{
  path: '/empresaform',
  name: 'EmpresaForm',
  component: () => import('../views/simpleForms/EmpresaForm.vue'),
  props: () => ({
    p_idEmpresa: Number(window.sessionStorage.getItem("idEmpresa")),
  })
},
  {
//    path: '/facturaform/:p_idfactura',
    path: '/facturaform',
    name: 'FacturaForm',
    component: FacturaForm
  },
  {
    path: '/informeinterform/:p_numero_atencion/:p_idinterconsulta',
    name: 'InformeInterForm',
    component: InformeInterForm
  },
  {
    path: '/interconsultadestinoform/:p_numero_atencion/:p_idinterconsulta',
    name: 'InterconsultaDestinoForm',
    component: InterconsultaDestinoForm
  },
  {
    path: '/interconsultaform/:p_opcion/:p_numero_atencion/:p_idinterconsulta',
    name: 'InterconsultaForm',
    component: InterconsultaForm
  },
{
  path: '/medicoform',
  name: 'MedicoForm',
  component: () => import('../views/simpleForms/MedicoForm.vue'),
  props: () => ({
    p_idMedico: Number(window.history.state?.idMedico),
  })
},
{
  path: '/personaform',
  name: 'PersonaForm',
  component: () => import('../views/simpleForms/PersonaForm.vue'),
  props: () => ({
    p_pagina:    window.history.state?.pagina,
    p_idPersona: Number(window.history.state?.idPersona),
  })
},
  {
    path: '/suscripcionform/:p_idsuscripcion',
    name: 'SuscripcionForm',
    component: SuscripcionForm
  },
  {
    path: '/tratamientoform',
    name: 'TratamientoForm',
    component: TratamientoForm
  },
  {
    path: '/usuarioform/:p_idusuario',
    name: 'UsuarioForm',
    component: UsuarioForm
  },
  {
    path: '/usuarioresumenform/:p_idusuario',
    name: 'UsuarioResumenForm',
    component: UsuarioResumenForm
  },
  {
    path: '/atencionform',
    name: 'AtencionForm',
    component: AtencionForm,
    props: () => ({
      p_idAtencion: Number(window.history.state?.idAtencion)
    })
  },
{
  path: '/interconsultaorigenform',
  name: 'InterconsultaOrigenForm',
  component: () => import('../views/simpleForms/InterconsultaOrigenForm.vue'),
  props: () => ({
    p_numeroAtencion:  window.history.state?.numeroAtencion,
    p_estadoAtencion:  window.history.state?.estadoAtencion,
    p_idInterconsulta: Number(window.history.state?.idInterconsulta),
  })
},
{
  path: '/referenciaform',
  name: 'ReferenciaForm',
  component: () => import('../views/simpleForms/ReferenciaForm.vue'),
  props: () => ({
    p_idAtencion:     Number(window.history.state?.idAtencion),
    p_numeroAtencion: window.history.state?.numeroAtencion,
    p_idReferencia:   Number(window.history.state?.idReferencia),
    p_estadoAtencion: window.history.state?.estadoAtencion,
    p_pagina:         window.history.state?.pagina,
  })
},
];
